import { Flex } from "@chakra-ui/layout";
import { StatusProcuracaoEnum } from "core/features/assembleia/typings/procuracao";
import colors from "core/resources/theme/colors";
import SelectableButton from "ui/components/Button/SelectableButton";
import InputSearch from "ui/components/Input/InputSearch";

export interface HeaderTableProps {
  onSearch: (q?: string) => void;
  value: string;
  selectedStatus: StatusProcuracaoEnum | undefined;
  setSelectedStatus: (status: StatusProcuracaoEnum | undefined) => any;
}

function HeaderTable({
  onSearch,
  value,
  selectedStatus,
  setSelectedStatus,
}: HeaderTableProps) {
  const onUnselect = () => setSelectedStatus(undefined);
  return (
    <Flex w="100%">
      <Flex w="100%" gridGap={"16px"}>
        <InputSearch
          defaultValue={value}
          onSearch={(v) => onSearch(v)}
          maxW={450}
          placeholder="Procurar pelo nome do morador ou representante"
        />

        <Flex gridGap="8px 8px">
          <SelectableButton
            selected={selectedStatus === StatusProcuracaoEnum.Pendente}
            onClick={() => setSelectedStatus(StatusProcuracaoEnum.Pendente)}
            onUnselect={onUnselect}
            rounded="full"
            selectedColor={colors.red}
            fontSize="14px"
          >
            Pendente
          </SelectableButton>
          <SelectableButton
            selected={selectedStatus === StatusProcuracaoEnum.EmAnalise}
            onClick={() => setSelectedStatus(StatusProcuracaoEnum.EmAnalise)}
            onUnselect={onUnselect}
            rounded="full"
            selectedColor={colors.yellow}
            fontSize="14px"
          >
            Em análise
          </SelectableButton>
          <SelectableButton
            selected={selectedStatus === StatusProcuracaoEnum.Aprovada}
            onClick={() => setSelectedStatus(StatusProcuracaoEnum.Aprovada)}
            onUnselect={onUnselect}
            rounded="full"
            selectedColor={colors.green500}
            fontSize="14px"
          >
            Aprovada
          </SelectableButton>
          <SelectableButton
            selected={selectedStatus === StatusProcuracaoEnum.Rejeitada}
            onClick={() => setSelectedStatus(StatusProcuracaoEnum.Rejeitada)}
            onUnselect={onUnselect}
            rounded="full"
            selectedColor={colors.red}
            fontSize="14px"
          >
            Rejeitada
          </SelectableButton>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default HeaderTable;
